import 'intersection-observer'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import './registerServiceWorker'
import './screen'

import './assets/fonticons/style.css'
import './ui/styles/base/_animations.scss'
import './ui/styles/base/_base.scss'
import './ui/styles/base/_typography.scss'
import './ui/styles/base/_utilities.scss'

import './ui/styles/layout/layout.scss'

import Vue from 'vue'
import PortalVue from 'portal-vue'
import VueSkeletonLoading from 'vue-loading-skeleton'
import ScrollLock from 'vue-lock-scroll'
import { RecycleScroller, DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import VueObserveVisibility from 'vue-observe-visibility'
import { Storage } from '@capacitor/storage'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

import NotifyPlugin from './components/Notify/plugin'
import StoragePlugin from './plugins/storage'
import DetectMobile from './plugins/detectMobile'

import { getDomainList } from './domainsList'
import { createProvider } from './vue-apollo'

// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
  const onejan = new Date(this.getFullYear(), 0, 1)
  const today = new Date(this.getFullYear(), this.getMonth(), this.getDate())
  const dayOfYear = ((today - onejan + 86400000) / 86400000)
  return Math.ceil(dayOfYear / 7)
}

Vue.config.productionTip = false

Vue.use(VueSkeletonLoading)
Vue.use(PortalVue)
Vue.use(ScrollLock, {
  propName: '$locker'
})

Vue.use(NotifyPlugin)
Vue.use(StoragePlugin)
Vue.use(DetectMobile)
Vue.use(VueObserveVisibility)

Vue.component('RecycleScroller', RecycleScroller)
Vue.component('DynamicScroller', DynamicScroller)
Vue.component('DynamicScrollerItem', DynamicScrollerItem)

const SEARCH_PARAMS = new URLSearchParams(window.location.search)

async function setLang (searchParams) {
  const fiveDigitsLang = {
    ru: 'ru-RU',
    en: 'en-US',
    es: 'es-MX',
    uk: 'uk-UA',
    kk: 'kk-KZ'
  }

  const fiveDigitsLangReverse = {
    'ru-RU': 'ru',
    'en-US': 'en',
    'es-MX': 'es',
    'uk-UA': 'uk',
    'kk-KZ': 'kk'
  }

  if (searchParams.has('locale') && fiveDigitsLang[searchParams.get('locale')]) {
    await Storage.set({ key: 'lang', value: searchParams.get('lang') })
  } else if (searchParams.has('locale') && fiveDigitsLangReverse[searchParams.get('locale')]) {
    await Storage.set({ key: 'lang', value: fiveDigitsLangReverse[searchParams.get('locale')] })
  }
}

async function setInviter (searchParams) {
  if (searchParams.has('u')) {
    await Storage.set({ key: 'inviter', value: searchParams.get('u') })
  }
}

setLang(SEARCH_PARAMS)
  .then(() => {
    return setInviter(SEARCH_PARAMS)
  })
  .then(() => {
    return getDomainList()
  })
  .then(domainList => {
    Vue.prototype.$getEnv = {
      backendPath: domainList.getActiveBackendPath,
      billPath: domainList.getActiveBillPath,
      staticPath: domainList.getActiveStaticPath,
      endpoint: domainList.getActiveEndpoint,
      productionStaticPath: domainList.productionStaticPath
    }

    new Vue({
      router,
      apolloProvider: createProvider({}, domainList),
      i18n,
      render: h => h(App)
    }).$mount('#app')
  })
